import type { ComplianceLanguageSettings, Nullable } from '@iheartjane/types';
import capitalize from 'lodash-es/capitalize';
import startCase from 'lodash-es/startCase';

export function getSpecialType(
  specialType: string,
  complianceLanguage?: Nullable<ComplianceLanguageSettings>,
  extendedDealsLabelsEnabled = false
) {
  switch (specialType) {
    case 'bundle':
      return capitalize(complianceLanguage?.['bundle'] || '') || 'Bundle';
    case 'product':
    case 'bulk_pricing':
    case 'cart_total':
      return extendedDealsLabelsEnabled
        ? capitalize(complianceLanguage?.[specialType] || '') ||
            startCase(specialType)
        : startCase(specialType);
    default:
      return startCase(specialType);
  }
}
